import axios from 'axios'
import { Loading, MessageBox, Message } from 'element-ui'
import router from '../router'
import store from '../store'
import base from '@/utils/index'
import globalConfig from '@/config'
import { loadingWhiteList, noToken, codeMsg, errorMsg, tokenErrorPath, loadingText } from './config'

const baseFunc = base()
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 100000 // request timeout
})
// 需要设置更长的超时时间的接口
const longerTimeout = ['/euFarmerInfo/farmer/export', '/euFarmerInfo/export']
// 那么 showFullScreenLoading() tryHideFullScreenLoading() 要干的事儿就是将同一时刻的请求合并。
// 声明一个变量 needLoadingRequestCount，每次调用showFullScreenLoading方法 needLoadingRequestCount + 1。
// 调用tryHideFullScreenLoading()方法，needLoadingRequestCount - 1。needLoadingRequestCount为 0 时，结束 loading。
let needLoadingRequestCount = 0
let fullLoading
// 登录报错次数
let loginErrorCount = 0
export const showLoading = () => {
  if (needLoadingRequestCount === 0) {
    fullLoading = Loading.service({
      background: 'rgba(0, 0, 0, .2)',
      text: loadingText,
      spinner: 'el-icon-loading'
    })
  }
  needLoadingRequestCount++
}

export const tryHideLoading = () => {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    fullLoading.close()
  }
}

service.interceptors.request.use(
  config => {
    // 成员汇总的导出接口耗时较长，修改超时时间
    if (longerTimeout.includes(config.url)) {
      config.timeout = 300000
    }
    // 如果没有权限则先进行拦截，权限存在store中，如果没有则往storage中取
    let permission = []
    if (!store.state.apiPermission.length) {
      permission = baseFunc.getUserApiPermission()
      store.commit('setApiPermission', permission)
    } else {
      permission = store.state.apiPermission
    }
    let url = '/api' + String(config.url).replace(String(config.baseURL), '')
    if (permission.indexOf(url) < 0 && globalConfig.needApiPermission && noToken.indexOf(url) < 0) {
      Message({
        message: url + '接口没有权限',
        type: 'error'
      })
      return Promise.reject(new Error(config.url + ' has no permission'))
    }
    if (noToken.indexOf(config.url) < 0) {
      if (baseFunc.getLocalStorage('token')) { // 判断是否存在token，如果存在的话，则每个http header都加上token
        config.headers.Authorization = baseFunc.getLocalStorage('token')
      } else {
        if (loginErrorCount > 0) {
          return Promise.reject(new Error('no token'))
        } else {
          loginErrorCount++
          MessageBox.alert('请先登录', '', {}).then(function () {
            localStorage.clear() // 主要为了删除localStorage中的页面权限userPageInfo
            loginErrorCount = 0
            router.push({ path: tokenErrorPath })
          })
        }
        return Promise.reject(new Error('no token'))
      }
    }
    if (loadingWhiteList.indexOf(config.url) < 0) {
      showLoading()
    }
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

// 重写
const showMessage = Symbol('showMessage')
class DonMessage {
  success (options, single = true) {
    this[showMessage]('success', options, single)
  }
  warning (options, single = true) {
    this[showMessage]('warning', options, single)
  }
  info (options, single = true) {
    this[showMessage]('info', options, single)
  }
  error (options, single = true) {
    this[showMessage]('error', options, single)
  }

  [showMessage] (type, options, single) {
    if (single) {
      // 判断是否已存在Message
      if (document.getElementsByClassName('el-message').length === 0) {
        Message[type](options)
      }
    } else {
      Message[type](options)
    }
  }
}
const debouncedShowAlert = baseFunc.debounce(function() {
  MessageBox.alert(codeMsg.tokenExpire.msg, '', {}).then(function () {
    fullLoading.close()
    baseFunc.setLocalStorage('token', '')
    localStorage.clear()
    window.localStorage.removeItem('userPageInfo') // 删除localStorage中对应页面权限userPageInfo的key以及key中的内容（不清除的话无法跳到登录页）
    loginErrorCount = 0
    router.push({ path: tokenErrorPath })
  }) 
}, 500)
// 使用这个
var MessageOnce = new DonMessage();
const debouncedMessageOnce = baseFunc.debounce(function(response) {
  MessageOnce.error({ message: response.data.message });
}, 500)

const MessageBoxAlert = baseFunc.debounce(function() {
  MessageBox.alert(errorMsg, '', {}).then(() => {
    tryHideLoading()
  })
}, 500)
// http request 拦截器
service.interceptors.response.use(
  response => {
    if (response.data.code === codeMsg.otherError.code) {
      MessageBox.alert(response.data.message, '', {}).then(function () { })
    }
    // token失效
    if (response.data.code === codeMsg.tokenExpire.code) {
      if (loginErrorCount > 0) {
        loginErrorCount = 0
        // return Promise.reject(response)
      } else {
        loginErrorCount++
        debouncedShowAlert()
      }
      return Promise.reject(response)
    }
    if ((response.data.code === 500 || response.data.code === 1002) && response.data.message) {
      debouncedMessageOnce(response)
    }
    tryHideLoading()
    if (response.headers['content-disposition'] || response.data.code === 0) {
      return response.data
    }
  },
  error => {
    if (error.message !== 'no token') {
      MessageBoxAlert()
      // MessageBox.alert(errorMsg, '', {}).then(() => {
      //   tryHideLoading()
      // })
    }
    console.log(error)
  }
)

// 将axios 的 post 方法
export function $post (params) {
  return new Promise((resolve, reject) => {
    service.post(params.url, params.data).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

// 将axios 的 get 方法
export function $get (params) {
  return new Promise((resolve, reject) => {
    service.get(params.url, { fileName: params.data }, { responseType: params.responseType }
    ).then(res => {
      resolve(res) // 返回请求成功的数据 data
    }).catch(err => {
      reject(err)
    })
  })
}

// 导出responseType
export function $download (params) {
  return new Promise((resolve, reject) => {
    service.post(params.url, params.data, {
      responseType: 'arraybuffer'
    }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

export default service
